import { Button, Form, Switch } from 'antd';
import React, { useState } from 'react';
import styles from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { SizeFittingTable, Input } from '@/src/components/Antd';
import Actions from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import { EnumTablePosition } from 'src/types/common/common';
import ErrorModal from '@/src/components/ErrorModal/ErrorModal';
import ErrorModalTitle from '@/src/components/ErrorModal/ErrorModalTitle';
import { urlReg } from '@/src/tools/regExp';

const AddUrlModal = ({ onCancel, onConfirm, getI18n, urlReg }) => {
  const [value, setValue] = useState('');
  const [error, setError] = useState('');

  const handleChange = (val) => {
    const v = typeof val === 'string' ? val : val?.target?.value || '';
    setValue(v);
    if (v && !urlReg.test(v)) {
      setError(getI18n('storeLinkLibrary.detail.urlTip'));
    } else {
      setError('');
    }
  };

  return (
    <>
      <div className={styles.addModalContainer}>
        <div className={styles.addModalTitle}>
          {getI18n('thirdPartyAPI.callback.callbackURL')}*
        </div>
        <Input
          className={styles.addModalInput}
          value={value}
          onChange={handleChange}
        />
        {error && <div className={styles.errorText}>{error}</div>}
      </div>
      <div className={styles.modalBtns}>
        <Button
          style={{ marginRight: 12 }}
          onClick={() => {
            onCancel();
          }}>
          {getI18n('general.discard')}
        </Button>
        <Button
          type='primary'
          disabled={!value || !!error}
          onClick={() => {
            if (!value || error || (value && !urlReg.test(value))) return;
            onConfirm(value);
          }}>
          {getI18n('general.done')}
        </Button>
      </div>
    </>
  );
};

const CallbackSetting = ({ form, modalOp, disableEdit, onValuesChange }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { setShowModal, setModalTitle, setModalContent } = modalOp || {};

  const handleDelete = (record) => {
    const currentUrls = form.getFieldValue('urls') || [];
    const newUrls = currentUrls.filter((_, i) => i !== record.index);
    form.setFieldsValue({ urls: newUrls });
    setShowModal(false);
    onValuesChange();
  };

  const deleteCallbackUrl = (record) => {
    if (!setShowModal) return;
    setShowModal(true);
    setModalTitle(
      <ErrorModalTitle>
        {getI18n('thirdPartyAPI.callback.deleteCallback')}
      </ErrorModalTitle>,
    );
    setModalContent(
      <ErrorModal
        setModal={setShowModal}
        onSubmit={() => handleDelete(record)}
        okText={getI18n('general.delete')}
        errorText={getI18n('thirdPartyAPI.callback.deleteDesc')}
      />,
    );
  };

  const addCallbackModal = () => {
    if (!setShowModal) return;
    setShowModal(true);
    setModalTitle(getI18n('thirdPartyAPI.callback.addCallbackURL'));
    setModalContent(
      <AddUrlModal
        getI18n={getI18n}
        urlReg={urlReg}
        onCancel={() => setShowModal(false)}
        onConfirm={(url) => {
          const currentUrls = form.getFieldValue('urls') || [];
          form.setFieldsValue({ urls: [...currentUrls, url] });
          setShowModal(false);
          onValuesChange();
        }}
      />,
    );
  };

  return (
    <div className={styles.settingContainer}>
      <div className={styles.settingContent}>
        <div className={styles.settingContentContainer}>
          {
            <Form.Item
              className={styles.settingContentSwitch}
              name={'enabled'}
              valuePropName={'checked'}
              colon={false}
              label={getI18n('thirdPartyAPI.callback.enablecallback')}>
              <Switch disabled={disableEdit} />
            </Form.Item>
          }
          <div className={styles.callbackDesc}>
            {getI18n('thirdPartyAPI.callback.desc')}
          </div>
          {
            <Form.Item name='urls' noStyle>
              <></>
            </Form.Item>
          }
          {
            <Form.Item
              noStyle
              shouldUpdate={(p, c) => {
                return p.enabled !== c.enabled || p.urls !== c.urls;
              }}>
              {({ getFieldValue }) => {
                const enabled = getFieldValue('enabled');
                const urls = getFieldValue('urls') || [];

                const tableData = urls.map((item, index) => {
                  if (typeof item === 'string') {
                    return { url: item, index };
                  }
                  return { ...item, index };
                });

                const columns = [
                  {
                    title: getI18n('general.uRL'),
                    dataIndex: 'url',
                    key: 'url',
                    default: true,
                    childGenerate: (text) => text || '-',
                  },
                  {
                    position: EnumTablePosition.mid,
                    key: 'action',
                    titleGenerate: () =>
                      getI18n(
                        'general.advancedFilters.commonStoreProductsWithTable.actions',
                      ),
                    dataIndex: 'action',
                    childGenerate: (text, record) => {
                      return (
                        <Actions
                          disableDelete={disableEdit}
                          onDelete={() => deleteCallbackUrl(record)}
                        />
                      );
                    },
                    default: true,
                    width: 120,
                  },
                ];

                return (
                  <React.Fragment>
                    {enabled && urls.length > 0 && (
                      <div className={styles.tableContainer}>
                        <SizeFittingTable
                          rowKey={(record, index) => `url-${index}`}
                          pagination={false}
                          id='callbackUrlsTable'
                          dataSource={tableData}
                          columns={columns}
                        />
                      </div>
                    )}
                    {enabled && urls.length < 5 && (
                      <Button
                        className={styles.addcallbackurl}
                        disabled={disableEdit}
                        onClick={addCallbackModal}>
                        {getI18n('thirdPartyAPI.callback.addCallbackURL')}
                      </Button>
                    )}
                  </React.Fragment>
                );
              }}
            </Form.Item>
          }
        </div>
      </div>
    </div>
  );
};
export default CallbackSetting;
